module.exports = "//d274d294w9cx2v.cloudfront.net/c3f8cd81aee3cb5d79d0a6430006d4e8fa5127d1/images/digital-invites.jpg";